import { Facet } from '@codemirror/state';
import { ViewPlugin } from '@codemirror/view';

// Define a facet to store state for the CodeMirror plugin
const actionsGutterFacet = Facet.define();

// Creates a gutter on the right side of the editor, and renders the provided
// dom element into the gutter.
export function actionsGutter(dom) {
  return [actionsGutterPlugin, actionsGutterFacet.of({ dom })];
}

export const actionsGutterPlugin = ViewPlugin.fromClass(
  class {
    dom;

    constructor(view) {
      // Create a dom element to add to the scrollDOM
      this.dom = document.createElement('div');
      this.dom.className = 'cm-actions-gutter';

      // Get the facet for this plugin
      const facet = view.state.facet(actionsGutterFacet)[0];
      // If the facet has a dom property, append it to the above dom element
      if (facet?.dom) {
        this.dom.append(facet.dom);
      }

      // Insert the plugin dom element to the scrollDom, after the content so
      // it shows up on the right
      view.scrollDOM.insertBefore(this.dom, view.contentDOM.nextSibling);
    }

    destroy() {
      this.dom.remove();
    }
  },
);
